"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePhoneAppService = void 0;
const web_events_1 = require("../constants/web-events");
const usePhoneAppService = () => {
    return {
        invoke: (type, args) => {
            if (!type) {
                return false;
            }
            const csAction = window.invokeCSharpAction(JSON.stringify(Object.assign({ type }, args)));
            return Promise.resolve(csAction);
        },
        WEB_EVENTS: web_events_1.WEB_EVENTS
    };
};
exports.usePhoneAppService = usePhoneAppService;
//# sourceMappingURL=phone-app-service.js.map